var path = 'templates/dialogs/thumbnail.html';
var html = "<md-dialog aria-label=\"\"> <img ngf-thumbnail=img> </md-dialog> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/dialogs/thumbnail.html
// module id = 15
// module chunks = 0